import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import { ButtonPurpose } from '@mhe/reader/common/button';

@Component({
  selector: 'rdrx-modal-header',
  templateUrl: './modal-header.component.html',
  styleUrls: ['./modal-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class ModalHeaderComponent {
  @ViewChild('closeButton', { read: ElementRef })
  private readonly closeButton?: ElementRef<HTMLButtonElement>;

  @Input() withClose = true;
  @Output() closeEvent = new EventEmitter();

  ButtonPurpose = ButtonPurpose;

  focusCloseButton(): void {
    this.closeButton?.nativeElement.focus();
  }

  closeClick(): void {
    this.closeEvent.emit();
  }
}
